// shim
import promiseFinally from 'promise.prototype.finally'

import Vue from 'vue'
import App from './App'
import { sync } from 'vuex-router-sync'
import store from './store'
import router from './router'
import * as directives from './utils/directives'
import * as filters from './utils/filters'
import Tooltip from '@/plugins/tooltip'

promiseFinally.shim()

Vue.config.productionTip = false

// register global utility directives.
Object.keys(directives).forEach(key => {
  Vue.directive(key, directives[key])
})

// register global utility filters.
Object.keys(filters).forEach(key => {
  Vue.filter(key, filters[key])
})

sync(store, router)

Vue.use(Tooltip)

/* eslint-disable no-new */
window.app = new Vue({
  el: '#app',
  router,
  store,
  render: h => h(App)
})



// WEBPACK FOOTER //
// ./src/main.js